import { logError } from '~/utilities/loggers';
import {
  ProgressMeter,
  ProgressMeterText,
  TimerBackground,
  TimerContainer,
  TimerForeground
} from './Timer.styles';

interface OwnProps {
  children?: React.ReactNode;
  diameter?: number;
  percentage: number;
  strokeWidth?: number;
}

export default function Timer({
  children,
  diameter = 80,
  percentage,
  strokeWidth = 5
}: OwnProps) {
  if (percentage > 1) {
    logError('Percentage cannot be greater than 1.0');
  }

  return (
    <TimerContainer>
      <ProgressMeter
        diameter={diameter}
        percentage={percentage}
        strokeWidth={strokeWidth}
      >
        <TimerBackground />
        {percentage > 0 && <TimerForeground />}
      </ProgressMeter>

      <ProgressMeterText>{children}</ProgressMeterText>
    </TimerContainer>
  );
}
